/* ==========================================================================
   Torque Conversion and Extension Calculator
   Self-contained. Loaded only on this calculator's page.
   No shared dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pc-tqc]');
  if (!root) return;

  var NM_PER_FTLB  = 1.3558179483;
  var INLB_PER_FTLB = 12;
  var NM_PER_KGM   = 9.80665;

  /* ====================================================================
     compute(input) -> result

     PURE. No DOM, no network, no globals. All calculator logic lives here
     so it can be reasoned about and tested in isolation.
     ==================================================================== */
  function toFtLb(v, unit) {
    if (unit === 'nm')   return v / NM_PER_FTLB;
    if (unit === 'inlb') return v / INLB_PER_FTLB;
    if (unit === 'kgm')  return (v * NM_PER_KGM) / NM_PER_FTLB;
    return v;
  }

  function compute(input) {
    if (!isFinite(input.value) || input.value < 0) {
      return { ok: false, errors: ['Enter a torque value.'] };
    }

    var ftlb = toFtLb(input.value, input.unit);
    var nm   = ftlb * NM_PER_FTLB;
    var inlb = ftlb * INLB_PER_FTLB;
    var kgm  = nm / NM_PER_KGM;

    var figures = [
      { label: 'Foot-pounds', value: num(ftlb, 2) + ' ft-lb' },
      { label: 'Newton-metres', value: num(nm, 2) + ' Nm' }
    ];

    var rows = [
      { head: 'All units' },
      { label: 'Foot-pounds', value: num(ftlb, 2) + ' ft-lb' },
      { label: 'Newton-metres', value: num(nm, 2) + ' Nm' },
      { label: 'Inch-pounds', value: num(inlb, 1) + ' in-lb' },
      { label: 'Kilogram-metres', value: num(kgm, 3) + ' kg-m' }
    ];

    var status = { key: 'good', label: num(nm, 1) + ' Nm',
                   note: num(ftlb, 1) + ' ft-lb, ' + num(inlb, 0) + ' in-lb.' };
    var warnings = [];

    /* Extension correction. Only valid when the adapter extends in line with
       the wrench handle. */
    var L = input.wrench, E = input.ext;
    if (isFinite(L) && L > 0 && isFinite(E) && E !== 0) {
      var setting = ftlb * (L / (L + E));
      figures.push({
        label: 'Set the wrench to',
        value: num(setting, 1) + ' ft-lb',
        sub: 'To actually apply ' + num(ftlb, 1) + ' ft-lb at the fastener through a '
           + num(E, 2) + ' in offset on a ' + num(L, 1) + ' in wrench.'
      });
      rows.push({ head: 'With the adapter fitted' });
      rows.push({ label: 'Wrench setting', value: num(setting, 1) + ' ft-lb' });
      rows.push({ label: 'Also', value: num(setting * NM_PER_FTLB, 1) + ' Nm' });
      rows.push({ label: 'Correction factor', value: num(L / (L + E), 4) });
      status = { key: 'good', label: 'Set ' + num(setting, 1) + ' ft-lb',
                 note: 'That delivers ' + num(ftlb, 1) + ' ft-lb at the fastener.' };
      if (E > 0 && E / L > 0.5) {
        warnings.push('That adapter is long relative to the wrench. The correction is large, so double check the measurement before you trust the number.');
      }
    } else if (isFinite(L) && L > 0 && E === 0) {
      rows.push({ head: 'With the adapter fitted' });
      rows.push({ label: 'No offset entered', value: 'No correction needed' });
    }

    return { ok: true, errors: [], warnings: warnings, status: status,
             figures: figures, rows: rows };
  }

  /* ====================================================================
     Formatting
     ==================================================================== */
  function comma(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function num(n, dp) {
    if (!isFinite(n)) return '-';
    var v = Number(n).toFixed(dp == null ? 2 : dp);
    if (dp !== 0 && v.indexOf('.') > -1) v = v.replace(/\.?0+$/, '');
    var parts = v.split('.');
    return comma(parts[0]) + (parts[1] ? '.' + parts[1] : '');
  }

  function signed(n, dp) {
    if (!isFinite(n)) return '-';
    return (n > 0 ? '+' : '') + num(n, dp);
  }

  /* ====================================================================
     DOM wiring
     ==================================================================== */
  var FIELDS = [
      {
          "name": "value",
          "key": "v",
          "type": "number"
      },
      {
          "name": "unit",
          "key": "u",
          "type": "select"
      },
      {
          "name": "wrench",
          "key": "w",
          "type": "number"
      },
      {
          "name": "ext",
          "key": "e",
          "type": "number"
      }
  ];

  var els = {
    error:    root.querySelector('[data-r-error]'),
    status:   root.querySelector('[data-r-status]'),
    statusLbl:root.querySelector('[data-r-status-label]'),
    statusVal:root.querySelector('[data-r-status-value]'),
    statusNote:root.querySelector('[data-r-status-note]'),
    figures:  root.querySelector('[data-r-figures]'),
    rows:     root.querySelector('[data-r-rows]'),
    warnings: root.querySelector('[data-r-warnings]')
  };

  var STATUS_CLASSES = ['is-good','is-monitor','is-soon','is-now','is-critical'];

  function field(name) { return root.querySelector('[data-f="' + name + '"]'); }

  function readInput() {
    var o = {};
    FIELDS.forEach(function (f) {
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') o[f.name] = el.checked;
      else if (f.type === 'number') o[f.name] = parseFloat(el.value);
      else o[f.name] = el.value;
    });
    return o;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function renderFigures(figs) {
    els.figures.innerHTML = (figs || []).map(function (f) {
      return '<div class="pc-tqc__figure">'
        + '<div class="pc-tqc__figure-label">' + esc(f.label) + '</div>'
        + '<div class="pc-tqc__figure-value' + (f.muted ? ' is-muted' : '') + '">'
        + esc(f.value) + '</div>'
        + (f.sub ? '<div class="pc-tqc__figure-sub">' + esc(f.sub) + '</div>' : '')
        + '</div>';
    }).join('');
  }

  function renderRows(rows) {
    if (!els.rows) return;
    els.rows.innerHTML = (rows || []).map(function (r) {
      if (r.head) {
        return '<div class="pc-tqc__row pc-tqc__rows-head">' + esc(r.head) + '</div>';
      }
      return '<div class="pc-tqc__row">'
        + '<span class="pc-tqc__row-label">' + esc(r.label) + '</span>'
        + '<span class="pc-tqc__row-value">' + esc(r.value) + '</span>'
        + '</div>';
    }).join('');
  }

  function clearResult(message) {
    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      els.statusVal.textContent  = 'Waiting for your numbers';
      els.statusNote.textContent = message || '';
    }
    els.figures.innerHTML = '';
    if (els.rows) els.rows.innerHTML = '';
    if (els.warnings) els.warnings.style.display = 'none';
  }

  function render() {
    var input  = readInput();
    var result = compute(input);

    if (!result.ok) {
      els.error.textContent = result.errors[0];
      els.error.classList.add('is-shown');
      clearResult(result.errors[0]);
      return;
    }
    els.error.classList.remove('is-shown');

    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      if (result.status) {
        els.status.classList.add('is-' + result.status.key);
        els.statusVal.textContent  = result.status.label;
        els.statusNote.textContent = result.status.note || '';
      } else {
        els.statusVal.textContent  = '';
        els.statusNote.textContent = '';
      }
    }

    renderFigures(result.figures);
    renderRows(result.rows);

    if (els.warnings) {
      if (result.warnings && result.warnings.length) {
        els.warnings.textContent = result.warnings[0];
        els.warnings.style.display = '';
      } else {
        els.warnings.style.display = 'none';
      }
    }

    writePermalink(input);
  }

  /* ====================================================================
     Shareable result permalinks
     ==================================================================== */
  function writePermalink(input) {
    if (!window.history || !window.history.replaceState) return;
    var q = FIELDS.map(function (f) {
      var v = input[f.name];
      if (f.type === 'checkbox') return v ? f.key + '=1' : '';
      if (v == null || v !== v || v === '') return '';
      return f.key + '=' + encodeURIComponent(v);
    }).filter(Boolean).join('&');
    try {
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : ''));
    } catch (e) {}
  }

  function applyPermalink() {
    if (!window.URLSearchParams) return;
    var p = new URLSearchParams(window.location.search);
    var any = false;
    FIELDS.forEach(function (f) {
      if (!p.has(f.key)) return;
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') el.checked = p.get(f.key) === '1';
      else el.value = p.get(f.key);
      any = true;
    });
    return any;
  }

  /* ====================================================================
     Init
     ==================================================================== */
  ['input', 'change'].forEach(function (evt) {
    root.addEventListener(evt, function (e) {
      if (e.target.closest('[data-r-form]')) render();
    });
  });

  applyPermalink();
  render();

  /* Exposed for testing and debugging only. */
  window.PC_TQC = { compute: compute };
})();
